import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const ClientsListPage = lazy(
  () => import('@/containers/Views/Clients/ClientsListPage'),
);

const ClientDetails = lazy(
  () => import('@/containers/Views/Clients/ClientDetails'),
);

const ClientsRouter = (
  <Route path="clients">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.Clients} 
          permissions={EBasicActions.Find}
        >
          <ClientsListPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path=":clientId"
      element={(
        <PrivateRoute 
          pageName={EPage.Clients} 
          permissions={EBasicActions.Get}
        >
          <ClientDetails />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default ClientsRouter;
